import axiosServices from "../utils/axios";

interface FetchApiResponce{
    data: any[];
}

export const fetchPetsJobs = async() =>{
    const response = await axiosServices.get<FetchApiResponce>(`/petsjobs`);
    // console.log("res", response.data);
    return response.data.data;
}
